import React from 'react';

import { Footer, Header } from '$partials/global';
import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import { ModuleDispatcher } from '$partials/modules';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').MembershipLandingPage}
 */
const MembershipLandingPage = (props) => {
    const page = props.data.page;

    return (
        <>
            <Header
                {...props?.data?.header}
                pageType={page.__typename} />

            <main id='main-content'>
                <div className='layout-container layout-site-outer-padding pb-8 md:pb-16'>
                    {/* Hero content */}
                    <div className={'bg-surface-panel-green col-wrapper-breakout rounded-lg'}>
                        <div className='col-padding pt-24 pb-8 md:py-16'>
                            <h1 className='type-style-sans-display w-full sm:w-9/12 md:w-8/12'>
                                {page.title}
                            </h1>
                            {page.landingStandfirst && (
                                <h2 className='type-style-sans-h3 mt-8 w-full sm:w-9/12 md:w-7/12'>
                                    {page.landingStandfirst}
                                </h2>
                            )}
                            {page.panelButtons?.length > 0 && (
                                <div className='mt-24 md:mt-40 flex flex-wrap gap-x-8'>
                                    {page.panelButtons.map((button, idx) => {
                                        return (
                                            <React.Fragment key={button.id}>
                                                {button.ctaMobileUrlOverride ? (
                                                    <>
                                                        <Button
                                                            as='a'
                                                            data-analytics-action='click'
                                                            data-analytics-context='membership'
                                                            data-analytics-destination={button.ctaMobileUrlOverride}
                                                            data-analytics-id={`${page?.id}_membership_header_cta_${idx}`}
                                                            data-analytics-label={button.ctaLabel}
                                                            data-analytics-location='membership_header'
                                                            data-analytics-module='membership_header_cta'
                                                            className={`sm:hidden ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}`}
                                                            href={button.ctaMobileUrlOverride}>
                                                            {button.ctaLabel}
                                                        </Button>
                                                        <Button
                                                            as='a'
                                                            data-analytics-action='click'
                                                            data-analytics-context='membership'
                                                            data-analytics-destination={formatLinkBlockToUrl(button.ctaLink)}
                                                            data-analytics-id={`${page?.id}_membership_header_cta_${idx}`}
                                                            data-analytics-label={button.ctaLabel}
                                                            data-analytics-location='membership_header'
                                                            data-analytics-module='membership_header_cta'
                                                            className={`hidden sm:block ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass: ''}`}
                                                            href={formatLinkBlockToUrl(button.ctaLink)}>
                                                            {button.ctaLabel}
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <Button
                                                        as='a'
                                                        data-analytics-action='click'
                                                        data-analytics-context='membership'
                                                        data-analytics-destination={formatLinkBlockToUrl(button.ctaLink)}
                                                        data-analytics-id={`${page?.id}_membership_header_cta_${idx}`}
                                                        data-analytics-label={button.ctaLabel}
                                                        data-analytics-location='membership_header'
                                                        data-analytics-module='membership_header_cta'
                                                        className={`${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass: ''}`}
                                                        href={formatLinkBlockToUrl(button.ctaLink)}>
                                                        {button.ctaLabel}
                                                    </Button>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Modules */}
                    <div className='flex flex-col gap-y-8 md:gap-y-16 mt-8 md:mt-16'>
                        {page.modules.map((module, i) => (
                            <ModuleDispatcher
                                {...module }
                                key={i + module?.id} />))}
                    </div>
                </div>
            </main>

            <Footer
                {...props?.data?.footer}
                pageType={page.__typename} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default MembershipLandingPage;
